// extracted by mini-css-extract-plugin
export default {"statusWrapper":"styles_statusWrapper__F26Rk","Active":"styles_Active__TaPVj","Pending":"styles_Pending__IZpsB","ActiveUnderContract":"styles_ActiveUnderContract__osJ5J"};